import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../../shared/services/Base.service';

@Injectable({providedIn: 'root'})
export class ConfiguracaoSistemaService extends BaseService {
	constructor(){
		super('/ConfiguracaoSistema/')
	}

    GetStatusSistema(): Observable<any> {
		const url = 'ObterStatusSistema';
		return this._http.get(`${this._config.baseUrl}${this._api}${url}`);
	}

    PostAlterarStatusSistema(status : boolean):Observable<any>{
        const url = 'AlterarStatusSistema';
		return this._http.post(`${this._config.baseUrl}${this._api}${url}`, status);
    }
}